import { EmergencyQuestionValue } from '@dte/otw-azure-functions/src/report/questions/problemType/EmergencyQuestion';
import { ProblemTypeQuestionValue } from '@dte/otw-azure-functions/src/report/questions/problemType/ProblemTypeQuestion';
import { ReportQuestion } from '@dte/otw-azure-functions/src/report/questions/ReportQuestion';
import { filterBlank } from '@dte/otw-utils-core/src/lists/filterEmpty';
import { useReportAnswerValueSelected } from '../../../_atoms/draftReport/stepData';
import { ReportStep } from '../../../ReportSteps';

export function useIsTrappedContact(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.TrappedContact);
}

export function useIsPowerLine(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.PowerLine);
}

export function useIsPower(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Power);
}

export function useIsHazard(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Hazard);
}

export function useIsEquipment(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Equipment);
}

export function useIsTree(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Tree);
}

export function useIsPoleDebris(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Pole);
}

export function useIsArcing(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Arcing);
}
export function useIsContactWithEquipment(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Contact);
}

export function useIsFire(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Fire);
}
export function useIsInjuries(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Injuries);
}
export function useIsPublicTrapped(): boolean | undefined {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Trapped);
}

export function useSafetyNextStep(): ReportStep[] {
	const potentialSteps = [
		useIsTrappedContact() ? ReportStep.TrappedContact : undefined,
		useIsPowerLine() ? ReportStep.PowerLine : undefined,
		useIsPower() ? ReportStep.Power : undefined,
		useIsHazard() ? ReportStep.Hazard : undefined,
		useIsEquipment() ? ReportStep.EquipmentProblem : undefined,
		useIsTree() ? ReportStep.Tree : undefined,
		useIsPoleDebris() ? ReportStep.PoleDebris : undefined,
	];

	return filterBlank(potentialSteps);
}
